import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

/**
 * Generic menu link component for main navigation in the app sidebar
 * Opens content menu page in modal when accessed from non-content contexts
 */
const ContentMenuLink = ({ 
  children, 
  className = "", 
  contentType,
  useModalHook,
  menuModalComponent: MenuModalComponent,
  ...props 
}) => {
  const { shouldUseModal } = useModalHook();
  const [menuModalOpen, setMenuModalOpen] = useState(false);

  const handleClick = (e) => {
    if (shouldUseModal) {
      // If we should use modal, prevent navigation and show content menu modal
      e.preventDefault();
      setMenuModalOpen(true);
    }
    // If shouldUseModal is false, let the normal Link navigation handle it
  };

  const closeMenuModal = () => {
    setMenuModalOpen(false);
  };

  return (
    <>
      <Link
        to={`/${contentType}/`}
        className={className}
        onClick={handleClick}
        {...props}
      >
        {children}
      </Link>
      
      {/* Content Menu Modal */}
      <MenuModalComponent
        isOpen={menuModalOpen}
        onClose={closeMenuModal}
      />
    </>
  );
};

ContentMenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  useModalHook: PropTypes.func.isRequired,
  menuModalComponent: PropTypes.elementType.isRequired,
};

export default ContentMenuLink;
